import { keyframes } from '@emotion/react';
import { defineSlotRecipe } from '@chakra-ui/react';

const blobPulse = keyframes`
  from: {
    borderRadius: '20%',
    transform: 'scale(1) rotate(0deg)',
  },
  '20%': {
    borderRadius: '20%',
    transform: 'scale(2) rotate(0deg)',
  },
  '50%': {
    borderRadius: '50%',
    transform: 'scale(2) rotate(270deg)',
  },
  '80%': {
    borderRadius: '50%',
    transform: 'scale(1) rotate(270deg)',
  },
  to: {
    borderRadius: '20%',
    transform: 'scale(1) rotate(0deg)',
  }
`;

export const preloaderRecipe = defineSlotRecipe({
  className: 'preloader',
  slots: ['container', 'content'],
  base: {
    content: {
      animation: `${blobPulse} 2s ease-in-out 1s infinite`,
    },
  },
  variants: {
    variant: {
      fullWidth: {
        container: {
          inset: 0,
          pos: 'fixed',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
  },
});
